import { InjectionToken } from '@angular/core';
export const LOGGER_SERVICE_TOKEN = new InjectionToken('fc.gui.log');
